const mutations = {
    identidyInputMutation(state, value) {
        state.inputVerificationResult = { ...state.inputVerificationResult, ...value };
    },
};

export default mutations;